import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  Button,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import "./Services.css";
import { Images } from "../../helpers/Images";
import { Gallery } from "../../helpers/gallery";
import { useForm } from "@formspree/react";
import { toast } from "react-toastify";

const ServicesTemplate = () => {
  const [state, handleSubmit] = useForm("xzzrvldl");
  const services = [
    {
      title: "STEAM Based Curriculum",
      description:
        "Comprehensive learning programs designed to develop technical and soft skills in robotics, programming, and innovation.",
      image: Images.rec,
      features: [
        "Hands-on robotics projects",
        "Programming fundamentals",
        "Problem-solving workshops",
        "Team collaboration activities",
      ],
    },
    {
      title: "Organization Partnerships",
      description:
        "Collaborative programs for educational institutions and organizations to implement our innovative learning approach.",
      image: Gallery.gallery39,
      features: [
        "Customized curriculum integration",
        "Professional development support",
        "Resource sharing and networking",
        "Competition participation",
      ],
    },
    {
      title: "Trainer Development",
      description:
        "Comprehensive training programs for educators and trainers to become certified WeDo Challenge instructors.",
      image: Gallery.gallery48,
      features: [
        "Certification programs",
        "Teaching methodologies",
        "Technical skill development",
        "Ongoing support and resources",
      ],
    },
  ];

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    if (state.succeeded) {
      setFormData({
        name: "",
        phone: "",
        email: "",
        message: "",
      });
      toast.success(
        "Thank you for filling the form! We  will get back to you as soon as possible.",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnFocusLoss: false,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
          style: { backgroundColor: "#c11a83" },
        }
      );
    }
  }, [state.succeeded]);

  const scrollToForm = () => {
    document
      .getElementById("contact-form")
      .scrollIntoView({ behavior: "smooth" });
  };

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        backgroundColor: "#fff",
      }}
    >
      {/* Hero Section */}
      <Box
        sx={{
          background: `linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url(${Images.gold})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "300px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          textAlign: "center",
          padding: "20px",
        }}
      >
        <Box>
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: "2.5rem", md: "3.5rem" },
              fontWeight: "bold",
              marginBottom: "10px",
            }}
          >
            Our Services
          </Typography>
          <Typography
            variant="h5"
            sx={{
              maxWidth: "900px",
              margin: "0 auto",
              fontSize: { xs: "1rem", md: "1.5rem" },
            }}
          >
            Empowering the next generation through innovative education and
            training programs
          </Typography>
        </Box>
      </Box>

      {/* Services Grid */}
      <Box
        sx={{
          padding: { xs: "40px 20px", md: "80px 40px" },
          maxWidth: "1500px",
          margin: "0 auto",
        }}
      >
        <Grid container spacing={4}>
          {services.map((service, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Card
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  transition: "transform 0.3s ease-in-out",
                  "&:hover": {
                    transform: "translateY(-10px)",
                  },
                }}
              >
                <Box
                  sx={{
                    height: "200px",
                    overflow: "hidden",
                    position: "relative",
                  }}
                >
                  <img
                    src={service.image}
                    alt={service.title}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      filter: "brightness(0.8)",
                    }}
                  />
                </Box>
                <CardContent sx={{ flexGrow: 1, padding: "24px" }}>
                  <Typography
                    variant="h4"
                    sx={{
                      color: "primary.darker",
                      marginBottom: "16px",
                      fontWeight: "600",
                    }}
                  >
                    {service.title}
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "text.secondary",
                      marginBottom: "10px",
                      lineHeight: 1.6,
                    }}
                  >
                    {service.description}
                  </Typography>
                  <Box sx={{ marginTop: "auto" }}>
                    {service.features.map((feature, idx) => (
                      <Typography
                        key={idx}
                        variant="body2"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "8px",
                          color: "text.primary",
                        }}
                      >
                        <span
                          style={{
                            color: "#c11a83",
                            marginRight: "8px",
                            fontSize: "1.2rem",
                          }}
                        >
                          •
                        </span>
                        {feature}
                      </Typography>
                    ))}
                  </Box>
                  <Button
                    variant="contained"
                    onClick={scrollToForm}
                    sx={{
                      marginTop: "10px",
                      backgroundColor: "primary.main",
                      "&:hover": {
                        backgroundColor: "primary.dark",
                      },
                    }}
                  >
                    Get Now
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Call to Action Section */}
      <Box
        id="contact-form"
        sx={{
          backgroundColor: "primary.light",
          padding: { xs: "40px 20px", md: "80px 40px" },
          textAlign: "center",
        }}
      >
        <Typography
          variant="h3"
          sx={{
            color: "white",
            marginBottom: "24px",
            fontWeight: "600",
          }}
        >
          Ready to Get Started?
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: "white",
            marginBottom: "32px",
            maxWidth: "800px",
            margin: "0 auto 32px auto",
            lineHeight: 1.6,
            fontSize: "1.1rem",
          }}
        >
          We're excited to help you take the next step in your educational
          journey. Fill out the form below, and one of our dedicated team
          members will contact you within 24 hours to discuss how we can best
          serve your needs. Whether you're interested in our student programs,
          organization partnerships, or trainer development, we're here to guide
          you through the process.
        </Typography>

        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{
            maxWidth: "800px",
            margin: "0 auto",
            backgroundColor: "white",
            padding: "32px",
            borderRadius: "8px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                required
                label="Name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                required
                label="Phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                required
                label="Email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                required
                label="Message"
                name="message"
                multiline
                rows={4}
                value={formData.message}
                onChange={handleChange}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                sx={{
                  backgroundColor: "primary.main",
                  color: "white",
                  padding: "5px 30px",
                  fontSize: "1rem",
                  "&:hover": {
                    backgroundColor: "primary.dark",
                  },
                }}
              >
                Send Message
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default ServicesTemplate;
